import { createSelector } from 'reselect';

import { Selector } from 'react-redux';
import { CategoryState } from './categoryTypes';
import { RootState } from '../../../core/redux/model/rootStateModel';
import { CategoryGetResponse, CategoryValues } from '../model/categoryModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

const getRoot = (state: RootState) => state.category;

export const apiCategoryRequestState = createSelector<[Selector<RootState, CategoryState>], API_REQUEST_STATE>(
  getRoot,
  (root: CategoryState) => root.apiCategoryRequestState,
);

export const apiCategoryRequestError = createSelector<[Selector<RootState, CategoryState>], string | null>(
  getRoot,
  (root: CategoryState) => root.apiCategoryRequestError,
);

export const apiCategoriesRequestState = createSelector<[Selector<RootState, CategoryState>], API_REQUEST_STATE>(
  getRoot,
  (root: CategoryState) => root.apiCategoriesRequestState,
);

export const apiCategoriesRequestError = createSelector<[Selector<RootState, CategoryState>], string | null>(
  getRoot,
  (root: CategoryState) => root.apiCategoriesRequestError,
);

export const category = createSelector<[Selector<RootState, CategoryState>], CategoryGetResponse>(
  getRoot,
  (root: CategoryState) => root.category,
);

export const categories = createSelector<[Selector<RootState, CategoryState>], CategoryGetResponse[]>(
  getRoot,
  (root: CategoryState) => root.categories,
);

export const initialValues = createSelector<[Selector<RootState, CategoryState>], CategoryValues>(
  getRoot,
  (root: CategoryState) => {
    return {
      name: root.category.name ?? '',
      image: root.category.image?.iri ?? '',
      parent: root.category.parent?.iri ?? '',
      categoryOne: {
        value: '',
        key: '',
      },
      categoryTwo: {
        value: '',
        key: '',
      },
    };
  },
);

export const categoriesTree = createSelector<[Selector<RootState, CategoryState>], CategoryGetResponse[]>(
  getRoot,
  (root: CategoryState) => root.categoriesTree,
);
